import { useEffect } from 'react';
import { appCopy } from '@zibanu/shared';
import { useNotices } from './notices';

/** A new version is ready: "Update ready · Reload" until it's taken (spec 3A §6.5). */
export function UpdateNotice({ needRefresh, update }: { needRefresh: boolean; update: () => void }) {
  const { show } = useNotices();
  useEffect(() => {
    if (needRefresh) show(appCopy.updateReady(), { label: appCopy.reload(), run: update });
  }, [needRefresh, show, update]);
  return null;
}
